const getConfig = () => window.causemosConfig || {}

export default getConfig
